import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {BsModalService, ModalModule} from 'ngx-bootstrap';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {DateTimePickerModule} from 'ng-pick-datetime';
import {SharedModule} from '../../_shared/shared.module';
import {DepartmentTreeModule} from '../../_custom/department-tree/departments.module';
import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { ProjectDetailModule } from 'app/projects/project-detail/project-detail.module';
import { ProvincesComponent } from './provinces.component';
const routes: Routes = [
  {
    path: '',
    component: ProvincesComponent,
    data: {
      title: 'Quản lý phân vùng'
    },
  }
];
@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    TabsModule,
    DataTablesModule,
    HttpClientModule,
    ModalModule.forRoot(),
    DateTimePickerModule,
    ReactiveFormsModule,
    ProjectDetailModule,
    DepartmentTreeModule,
    TreeViewModule,
    AngularMultiSelectModule
  ],
  declarations: [ProvincesComponent]
})
export class ProvincesModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/provinces/provinces.module.ts